export const AccessStatistics = 'can access statistics';
export const UseEventLogger = 'can use event logger';

export const AccessSettings = 'can access settings';
export const ChangeWorkstation = 'can change workstation';
